define('gigaset_recurring/components/checkout/provider/billwerk/plugins/addressTypes',[
	"jquery",
	"lodash",
	"cartware/components/Config",
	"./addressTypes/step"
], function(
	$,
	_,
	Config,
	AddressTypeStep
) {
	function Plugin(checkout) {
		this.checkout = checkout;
		this.bindEvents();
	}

	Plugin.prototype = {
		checkout:	null,

		bindEvents: function() {
			this.checkout.on("hook.initializeSteps.before", function(steps, stepIds) {
				_.forEach(Config.get('recurring.quote.addressTypes'), function(id) {
					steps["step-address-type-" + id] = new AddressTypeStep(id);
				});
			});
		}
	};

	return Plugin;
});
